export const categoriesTypes = [
  {
    label: 'Pedido de Operação',
    value: 'pt.edp.request.operation.1',
  },
  {
    label: 'Pedido de Esclarecimento',
    value: 'pt.edp.request.operation.2',
  },
];
export interface RequestTypeModel {
  requestOperationTitle: string;
  requestOperationUniqueCode: string;
  requestOperationSelected: boolean;
}
